export const STORE_LINKS = {
  ios: "https://apps.apple.com/us/app/apekai/id6766222130",
  android: "https://play.google.com/store/apps/details?id=com.apekaistudios.places",
};
